const defaultCookieParams = {
  expirationDate: 7, // days
};

const motifs = ['rdv', 'programme', 'testeligibilite'];

interface SessionTokens {
  session_anonyme?: string;
  ga_cid?: string;
  fb_fbp?: string;
  fbclid?: string;
}

export const createSessionAndRetrieveTokensV2 = (): SessionTokens => {
  const currentUrlSP = new URLSearchParams(window.location.search);
  const gaParts = (getCookieValueFromHisName('_ga') ?? '').split('.');

  const gclid = getUrlParam('gclid');
  if (gclid) {
    setCookie('gclid', gclid, 90);
  }

  const maxAge = 3600;

  motifs.forEach((motif) => {
    if (currentUrlSP.get(motif)) {
      document.cookie = `motif=${motif};max-age=${maxAge};domain=lecolefrancaise.fr;path=/`;
      document.cookie = `${motif}=1;max-age=${maxAge};domain=lecolefrancaise.fr;path=/`;
    }
  });

  return {
    session_anonyme: getCookieValueFromHisName('_PHP_SESSION_ANONYME'),
    ga_cid:
      gaParts[2] && gaParts[3] ? `${gaParts[2]}.${gaParts[3]}` : undefined,
    fb_fbp: getCookieValueFromHisName('_fbp'),
    fbclid: getCookieValueFromHisName('fbclid'),
  };
};

export const getCookieValueFromHisName = (
  cname: string,
): string | undefined => {
  const name = cname + '=';
  const cookies = decodeURIComponent(document.cookie).split(';');

  for (let cookie of cookies) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length);
    }
  }
  return undefined;
};

const setCookie = (
  cookieName: string,
  cookieValue: string,
  expirationDays: number = defaultCookieParams.expirationDate,
  path = '/',
): void => {
  const expireDate = new Date();
  expireDate.setTime(
    expireDate.getTime() + expirationDays * 24 * 60 * 60 * 1000,
  );
  const expires = 'expires=' + expireDate.toUTCString();
  document.cookie =
    cookieName + '=' + cookieValue + ';' + expires + ';path=' + path;
};

const getUrlParam = (param: string): string | null => {
  const match = RegExp('[?&]' + param + '=([^&]*)').exec(
    window.location.search,
  );
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};
